import * as actionTypes from './actionTypes';

import { actions as notificationsActions } from '../../notifications';

export const getCounties = districtId => async (dispatch, _state, { apiSdk }) => {
    dispatch({ type: actionTypes.GET_COUNTIES_START });

    try {
        const response = await apiSdk.territories.getCounties(districtId);
        const { data } = response;

        dispatch({ type: actionTypes.GET_COUNTIES_SUCCESS, payload: data });
    } catch (error) {
        dispatch(notificationsActions.openErrorNotification('error.fetchCounties'));
        dispatch({ type: actionTypes.GET_COUNTIES_FAIL });
    }
};

export const reset = () => ({
    type: actionTypes.RESET
});
